export interface Video {
  id: string;
  videoUrl: string;
  name: string;
  channel: string;
}

export interface TemplateParameterValue {
  id: string;
  name: string;
  channel: string;
}

export enum EventTemplateType {
  YoutubeVideoReachViews = 'youtube_video_reach_views',
  YoutubeChannelReachLikes = 'youtube_channel_reach_likes',
}

const EVENT_TEMPLATE_TYPE_LABELS: Record<EventTemplateType, string> = {
  [EventTemplateType.YoutubeVideoReachViews]: 'Youtube video reach views',
  [EventTemplateType.YoutubeChannelReachLikes]: 'Youtube channel reach likes',
};

export const formatEventTemplateType = (type: EventTemplateType): string =>
  EVENT_TEMPLATE_TYPE_LABELS[type] ?? type;

export interface VideoEventSchedule {
  id: string;
  videoId: string;
  videoName: string;
  templateId: string;
  templateType: EventTemplateType;
  cron: string;
  durationMinutes: number;
  nextRunAt: Date;
}

export interface EventTemplate {
  id: string;
  type: EventTemplateType;
  name: string;
}
